export default __webpack_public_path__ + "static/media/Mend Weapon.0056eab6.png";